import { SortType } from '../../../ColumnHeader';
import { SavedListSortColumn } from '../constants';

export const SORT_LISTS_TITLE = 'Sort Player Lists';
export const SORT_LISTS_HEADING = 'Sort Player Lists By:';
export const SORT_LISTS_APPLY_LABEL = 'Apply';

// The four mobile sort options (Figma 101-6491): each maps a radio value to the (SavedListSortColumn,
// SortType) the feed sorts by plus its Figma title + grey description. The # Players column splits into
// Most (DESC) / Least (ASC); the direction defaults already match the desktop column-header sort
// (NAME→ASC, ACTIVITY→DESC, PLAYERS→DESC), with # Players (Least) the new PLAYERS+ASC case.
export const SORT_LIST_OPTIONS = [
    {
        value: 'name',
        title: 'Name',
        description: 'Alphabetical',
        column: SavedListSortColumn.NAME,
        type: SortType.ASC,
    },
    {
        value: 'recent-activity',
        title: 'Recent Activity',
        description: 'Lists where new activity has been posted.',
        column: SavedListSortColumn.ACTIVITY,
        type: SortType.DESC,
    },
    {
        value: 'players-most',
        title: '# Players (Most)',
        description: 'Lists with the most amount of players.',
        column: SavedListSortColumn.PLAYERS,
        type: SortType.DESC,
    },
    {
        value: 'players-least',
        title: '# Players (Least)',
        description: 'Lists with the least amount of players.',
        column: SavedListSortColumn.PLAYERS,
        type: SortType.ASC,
    },
];

// Recent Activity is the server default (no explicit orderBy), so it's the pre-selection when nothing
// is set yet or the active (column, type) doesn't match a named option.
export const DEFAULT_SORT_VALUE = 'recent-activity';

export const optionForValue = value => SORT_LIST_OPTIONS.find(option => option.value === value);

// Derive the pre-selected radio from the active sort. The PLAYERS column resolves to Most (DESC) vs
// Least (ASC) by SortType; an unset or unrecognized (column, type) falls back to the default.
export const selectedSortValue = (column, type) => {
    const match = SORT_LIST_OPTIONS.find(option => option.column === column && option.type === type);
    return match ? match.value : DEFAULT_SORT_VALUE;
};

export const sortLabelFor = (column, type) => optionForValue(selectedSortValue(column, type)).title;
